import { Component, OnInit, HostListener } from "@angular/core";
import { appConstants } from "src/app/constants/appConstants";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-refund-success",
  templateUrl: "./refund-success.component.html",
  styleUrls: ["./refund-success.component.scss"],
})
export class RefundSuccessComponent implements OnInit {
  constructor(private _commonService: CommonService) {}
  showScroll: boolean;
  showScrollHeight = 300;
  hideScrollHeight = 10;
  refundSuccessList: Array<any> = [];
  page: number = 1;
  total_page: number = 1;
  pageSize: number = 50;
  pageLimit: number[] = [5, 10, 25, 50, 100];
  reason: string = "";
  search: any = {
    phone: "",
    paymentId: "",
    refundId: "",
  };
  ngOnInit() {
    this.getRefundDoneList(this.page - 1);
  }
  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) > this.showScrollHeight
    ) {
      this.showScroll = true;
    } else if (
      this.showScroll &&
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) < this.hideScrollHeight
    ) {
      this.showScroll = false;
    }
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    })();
  }
  getPageFromService(page) {
    if (page) {
      this.getRefundDoneList(this.page - 1);
    }
  }

  Search(key) {
    let url = appConstants.FILTER + "?page=0&status=REFUND_DONE&";
    switch (key) {
      case "phone":
        url = url + "filterType=phone&filterKey=" + this.search.phone;
        break;
      case "paymentId":
        url = url + "filterType=paymentId&filterKey=" + this.search.paymentId;
        break;
      case "refundId":
        url = url + "filterType=refundId&filterKey=" + this.search.refundId;
        break;
    }
    this.getApiRequest(url);
  }
  getRefundDoneList(page) {
    let url = appConstants.REFUND_SUCCESS + page + "&pageSize=" + this.pageSize;
    this.getApiRequest(url);
  }
  changePageSize() {
    this.getRefundDoneList(this.page - 1);
  }
  getApiRequest(url) {
    this._commonService.getRequest(url).subscribe(
      (res) => {
        this.refundSuccessList = res.refundsInfo;

        this.total_page = res.totalPages * this.pageSize;
      },
      (err) => {
        console.log("err", err);
      }
    );
  }
}
